/**
 * Node Modules
 */
import React, { createElement } from 'react'
import marksy from 'marksy/jsx'
import { Link } from 'gatsby'

/**
 * Application Modules
 */
import './style.css'
import Section from '../../../components/section'

/**
 * Component
 */
export default function OurStory({ hed, dek }) {
  const compile = marksy({
    createElement,

    // You can override the default elements with
    // custom VDOM trees
    elements: {
      a({ href, title, target, children }) {
        return (
          <a target={target || '_blank'} rel="noreferrer" href={href}>
            {children}
          </a>
        )
      },
    },
  })

  return (
    <Section className="our-story" id="our-story">
      <div className="our-story__grid grid">
        <h2 className="our-story__hed column-start-1 column-end-6 column-start-2--t column-end-9--t">
          {hed}
        </h2>
        <div className="our-story__dek column-start-1 column-end-6 column-start-2--t column-end-11--t column-end-9--d">
          {compile(dek).tree}
        </div>
        <span className="our-story__by-line  column-start-1 column-end-6 column-start-2--t column-end-6--t column-end-4--d">
          <span className="our-story__by-name">Sean Herman, </span>
          <span className="our-story__by-title">Founder & CEO</span>
        </span>
        <div className="our-story__button column-start-1 column-end-6 column-start-2--t column-end-12--t">
          <Link className="reset button button button--yellow" to="/our-story">
            Our Story
          </Link>
        </div>
        <div className="our-story__book-image  column-start-1 column-end-6 column-start-2--t column-end-12--t">
          <img
            className="our-story__image our-story__image--t"
            src="/book-sean-panda.png"
            alt="Sean Herman Illustration"
          />
          <img
            className="our-story__image our-story__image--m"
            src="/book-sean-panda-mobile.png"
            alt="Sean Herman Illustration"
          />
        </div>
      </div>
      {/* <img className="our-story__image" src="/sean-and-panda.png" alt="Sean Herman Illustration" /> */}

      <svg className="our-story__curve our-story__curve--m" viewBox="0 0 375 24">
        <path
          fill="var(--white)"
          d="M0 14.332C55.245 5.16 117.561 0 183.5 0 252.642 0 317.8 5.673 375 15.697V24H0v-9.668z"
        />
      </svg>

      <svg className="our-story__curve our-story__curve--t" viewBox="0 0 1280 95">
        <path
          fill="var(--white)"
          d="M1280 97H0V74.604C187.628 27.207 406.613 0 640.5 0c233.471 0 452.094 27.11 639.5 74.351V97z"
        />
      </svg>
    </Section>
  )
}
